module.exports = __webpack_public_path__ + "img/pdficon.c1ae6d25.png";